<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5" >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('invitationsReceived')">
              Convites Recebidos!
            </h1>
            <h1 class="title">
              <span v-text="$ml.get('managementInvitations')" class="pb-2" >
              </span>
            </h1>

            <div class="card mb-3">
              <div class="card-header" v-text="$ml.get('awaitingResponse')">
                Aguardando Resposta
              </div>
              <div class="card-body">
                <div v-if="!listInvitePending.length">
                  <div class="align-self-center loading d-flex mt-1 w-100">
                    <div v-if="loading" class="c-loader m-1"></div>
                    <h6 v-else class="pb-1" v-text="$ml.get('youDontHaveAnyInvitationsWaiting')" >
                      Ainda não possui convites aguardando respostas!
                    </h6>
                  </div>
                </div>

                <div class="d-column flex-row mt-3" v-for="(item, index) in listInvitePending" :key="index"> 
                  <div class="h-profile h-profile-lg d-flex flex-column pb-3 align-items-center" :style=" listInvitePending.length - 1 == index ? 'border:none;' : '' " >
                    <div class="d-flex align-self-start">
                      <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="item.program_avatar" type="image/png" >
                        <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../../assets/images/default.png" alt="Avatar" />
                      </object>
                      <div class="pl-2 d-flex">
                        <div class="align-self-start mt-1">
                          <h6 class="pb-1">
                            <a class="link-block"> <strong v-text="item.program_name"></strong></a>
                            <VueCustomTooltip v-show="item.program_vpn_required" label="Este programa possui VPN">
                              <span  class="ico ico-vpn ml-2">
                                <img src="../../../assets/images/vpn.png" />
                              </span> 
                            </VueCustomTooltip>
                            <VueCustomTooltip :label="$ml.get('protectedByNDA')">
                              <span v-if="item.program_nda_required" class="ico ico-nda ml-2"> 
                                <img src="../../../assets/icons/security-shield.svg" />
                              </span>
                            </VueCustomTooltip>
                          </h6>
                          <p class="d-flex align-items-center">
                            <span class="align-self-center" v-text="$ml.with($utils.formatData(item.program_createdAt, $ml.get('ln'))).get('publishedDaysAgo')"></span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>
                    <div class="d-flex align-self-start h-profile">
                      <div class="h-profile-picture">
                        <div class="position-relative d-flex align-items-center ml-2" >
                          <object width="42" height="42" class="rounded-circle img-m" :data="item.person_avatar" type="image/png" >
                            <img width="42" height="42" class="rounded-circle img-m" src="../../../assets/images/default.png" alt="Avatar" />
                          </object>
                          <div v-show="item.hacker_verified" class="verify verify-invitation" >
                            <img src="../../../../src/assets/icons/badge-check.png" width="16" height="16" />
                          </div>
                          <div class="h-line h-line-avatar"><span></span></div>
                        </div>
                      </div>

                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100 dropleft" style="position:relative;">
                          <p>
                            <font v-text="$ml.get('youHaveBeenInvitedToSend')" >Você foi convidado para enviar relatórios à esse programa</font >
                            <span
                              class="time-small"
                              v-text="
                              $ml.with($utils.formatData(item.invitation_updatedAt ? item.invitation_updatedAt : item.invitation_createdAt, $ml.get('ln'))).get('ago')"
                              >
                            </span>
                          </p>

                          <b-dropdown :ref="'dropdown' + index" class="dropdown-links" >
                            <p class="dropdown-item h-options d-flex pl-3 pr-3 pt-2 pb-2 m-0" >
                              <span class="p-1" v-text="$ml.get('whatIsYourAction')" >Qual sua ação?</span >
                            </p>
                            <a
                              @click=" alterStatusInvites(item.invitation_id, 'accepted', index, item.program_id, item)"
                              class="pointer dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
                              v-text="$ml.get('acceptThisInvitation')"
                            >
                              Aceitar este Convite!
                            </a>
                            <a
                              @click=" alterStatusInvites(item.invitation_id, 'declined', index, item.program_id)"
                              class="pointer dropdown-item fail h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
                              v-text="$ml.get('declineThisInvitation')"
                            >
                              Recusar este Convite!
                            </a>
                          </b-dropdown>
                          <a
                            @click="showOption(index)"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <img
                              src="../../../../src/assets/icons/plus-circle.png"
                              class="pointer d-flex mb-4 ico-16"
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-header" v-text="$ml.get('invitationsAccepted')">
                Convites Aceitos
              </div>
              <div class="card-body">
                <div v-if="!listInviteAccepted.length">
                  <div class="align-self-center loading d-flex mt-1 w-100">
                    <div v-if="loading" class="c-loader m-1"></div>
                    <h6
                      v-else
                      class="pb-1"
                      v-text="$ml.get('youDontHaveAnyAcceptedInvitations')"
                    >
                      Ainda não possui convites aceitos!
                    </h6>
                  </div>
                </div>

                <div class="d-column flex-row mt-3" v-for="(item, index) in listInviteAccepted" :key="index" >
                  <div class="h-profile h-profile-lg d-flex flex-column pb-3 align-items-center" :style=" listInviteAccepted.length - 1 == index ? 'border:none;' : '' " >
                    <div class="d-flex align-self-start" style="height:60px">
                      <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="item.program_avatar" type="image/png" >
                        <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../../assets/images/default.png" alt="Avatar" />
                      </object>
                      <div class="pl-2 d-flex">
                        <div class="align-self-start ">
                          <h6 class="pt-1 m-0 p-0 pb-1">
                            <a v-if="item.program_status" class="link-block" :href="'/program/detail?' + item.program_id" >
                              <strong v-text="item.program_name"></strong>
                              <VueCustomTooltip v-show="item.program_vpn_required" label="Este programa possui VPN">
                                <span  class="ico ico-vpn ml-2">
                                  <img src="../../../assets/images/vpn.png" />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip :label="$ml.get('protectedByNDA')">
                                <span v-if="item.program_nda" class="ico ico-nda ml-2">
                                  <img src="../../../assets/icons/security-shield.svg" />
                                </span>
                              </VueCustomTooltip>
                            </a>
                            <a v-else class="link-block" :href="'/program/detail?' + item.program_id">
                              <strong v-text="item.program_name"></strong>
                            </a>
                          </h6>
                          <a
                            class="badge badge-warning text-white"
                            v-if="item.program_status == 'pending'"
                            v-text="$ml.get('pending')"
                            >Pendente</a>
                          <a
                            class="badge badge-success text-white"
                            v-show="item.program_status == 'in_progress'"
                            v-text="$ml.get('inProgress')"
                            >Em andamento
                          </a> 
                          <a
                            class="badge badge-secondary text-white"
                            v-show="item.program_status == 'paused'"
                            v-text="$ml.get('paused')"
                            >Pausado
                          </a>
                          <p class="mt-2 d-flex align-text-bottom">
                            <span
                              class="align-text-bottom"
                              v-text="$ml.with($utils.formatData(item.program_createdAt, $ml.get('ln'))).get('publishedDaysAgo')"> 
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile ">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="h-profile-picture">
                        <div
                          class="position-relative d-flex align-items-center ml-2"
                        >
                          <object
                            width="42"
                            height="42"
                            class="rounded-circle img-m"
                            :data="item.person_avatar"
                            type="image/png"
                          >
                            <img
                              width="42"
                              height="42"
                              class="rounded-circle img-m"
                              src="../../../assets/images/default.png"
                              alt="Avatar"
                            />
                          </object>
                          <div v-show="item.hacker_verified" class="verify verify-invitation" >
                            <img
                              src="../../../../src/assets/icons/badge-check.png"
                              width="16"
                              height="16"
                            />
                          </div>
                          <div class="h-line h-line-avatar"><span></span></div>
                        </div>
                      </div>
                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100" >
                          <p>
                            <font v-text="$ml.get('youAcceptedParticipateInThisProgram')"></font>
                            <span
                              class="time-small"
                              v-text="
                              $ml.with($utils.formatData(item.invitation_updatedAt ? item.invitation_updatedAt : item.invitation_createdAt, $ml.get('ln'))).get('ago')"> 
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center align-items-start" >
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                        <span class="circle-internal d-flex justify-content-center" >
                          <span class="circle-success"></span>
                        </span>
                      </div>
                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100" >
                          <p v-text="$ml.get('youAcceptedThisInvitation')">
                            Você aceitou esse convite
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <b-modal
      id="modal-nda"
      class="my-modal"
      data-bs-keyboard="false"
      hide-header
      size="xl"
      footer-bg-variant="light"
    >
      <b-container
        fluid="xl"
        style="max-height: 80vh !important; overflow-y: auto !important;"
      >
        <div class="col modal-body">
          <div v-show="htmlText" v-html="htmlText" class="m-4"></div>
        </div>
      </b-container>

      <template #modal-footer>
        <div class="w-100 float px-3">
          <p
            class="float-left mt-2 primary-text"
            v-text="$ml.get('agreementText')"
          >
            Você concorda com os termos do contrato de confidencialidade?
          </p>
          <b-button
            variant="primary"
            size="sm"
            class="float-right ml-3 btn-outline-extra"
            @click="rejectContract()"
            v-text="$ml.get('doNotAgree')"
          >
            Não Concordo
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="acceptContract()"
            v-text="$ml.get('agree')"
          >
            Concordo
          </b-button>  
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ProgramService from "../../../services/program.service";
import accountService from "../../../services/account.service";
import Swal from "sweetalert2";

export default {
  name: "Invitations",
  data() {
    return {
      listInvitePending: [],
      listInviteAccepted: [],
      loading: true,
      htmlText: "",
      nda: "",
      name: "",
      company_name: "",
      selected_invitation: "",
      loadingBtn: false,
      ndaMaxLengt: false,
    };
  },
  mounted() {
    this.changeInvites("pending");
    this.changeInvites("accepted");
  },

  methods: {
    showOption(index) {
      this.$refs["dropdown" + index][0].show();
    },
    changeInvites(status) {
      this.loading = true;
      ProgramService.getInvitesStatus(1, 10, status).then((response) => {
        this.loading = false;
        if (status == "pending") {
          this.listInvitePending = response.data.items;
        }
        if (status == "accepted") {
          this.listInviteAccepted = response.data.items;
        }
      });
    },
    async getAccount() {
      try {
        const { data } = await accountService.getAccountMy();
        const {pending_invitations} = data;

        this.$store.dispatch("setUser", {
            pending_invitations: pending_invitations,
          });
      } catch (error) {
        console.log(error);
      }
    },
    alterStatusInvites(id, status, index, programId, item) {
    // alterStatusInvites(id, status, index, programId) {
      var self = this;
      this.$refs["dropdown" + index][0].hide();
 
      if(item && !item.invitation_validated_by_mati && item.mati_token){
        Swal.fire({
          icon: "",  
          html: `
          ${item.program_vpn_required ? `<h4 class="pb-1 pt-2"> ${self.$ml.with('<b>VPN</b>').get("programWith")} </h4>` : 
          item.program_nda_required ? `<h4 class="pb-1 pt-2"> ${self.$ml.with('<b>NDA</b>').get("programWith")} </h4>` : ''} 
          <p class="mx-2">${self.$ml.get('toAcceptThisInvitation')}</p>`,  
          confirmButtonText: `<mati-button class="d-flex align-itens-center mati-button"
                  clientid="60904febf0a740001bd4f32d" 
                  flowId="60904febf0a740001bd4f32c" 
                  metadata='{ "token": "${item.mati_token}" }'
                />`,
          confirmButtonColor: "rgba(0,0,0,0)",   
          customClass: "custom_confirm"
        });
 

        return
      }
      
      
      ProgramService.putInvitesStatus(id, status).then(
        (response) => {
          if (response.data) {
            Swal.fire({
              icon: "success",
              title:
                status == "accepted"
                  ? self.$ml.get("invitationsAccepted")
                  : self.$ml.get("invitationDeclined"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            this.changeInvites("pending");
            this.changeInvites("accepted");
            this.getAccount();
          }
        },
        (error) => {
          this.loadingBtn = false;
          if (error.message == "Request failed with status code 406") {
            this.loadNda(programId);
            this.selected_invitation = id;
          } else if (error.message == "Request failed with status code 412") {
            Swal.fire({
              icon: "info",
              text:
                self.$ml.get("ndaVerificationRequired2") +
                "\n" +
                self.$ml.get("ndaVerificationRequired3"),
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              icon: "info",
              text: self.$ml.get("unableToCompleteThisRequest"),
              showConfirmButton: true,
            });
          }
        }
      );
    },
    controlTextArea() {
      const { textarea } = this.$refs;
      textarea.style.height =
        textarea.scrollHeight < 800 ? textarea.scrollHeight + "px" : 800 + "px";
      this.nda = textarea.value;
      if (textarea.value.length > 300000) {
        this.nda = textarea.value.substring(0, 300000);
        this.ndaMaxLengt = true;
      } else {
        this.ndaMaxLengt = false;
      }
    },
    async loadNda(programId) {
      this.selected_program = programId;
      this.htmlText = "";
      ProgramService.getNda(programId).then(
        (response) => {
          if (response.data.description) {
            this.nda = response.data.description;
            this.name = response.data.name;
            this.company_name = response.data.company_name;
            this.htmlText = "";
            this.htmlText = this.$utils.convertMarkedOld(
              this.nda,
              [],
              this.company_name,
              this.name
            );
            this.$bvModal.show("modal-nda");
          }
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      );
    },
    async acceptContract() {
      ProgramService.acceptNda(this.selected_invitation).then(
        (response) => {
          if (response.data) {
            Swal.fire({
              icon: "success",
              title: this.$ml.get("ndaAccepted"),
              showConfirmButton: false,
              timer: 3000,
            });
            this.$bvModal.hide("modal-nda");
            this.changeInvites("pending");
            this.changeInvites("accepted");
          }
        },
        () => {
          this.$bvModal.hide("modal-nda");
          Swal.fire({
            icon: "info",
            title: this.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      );
    },
    async rejectContract() {
      this.$bvModal.hide("modal-nda");
    },
  },
};
</script>

<style scoped>
.avatar-wrapper {
  height: 62px;
  width: 62px;
}
.dropdown-links {
  width: 210px;
  position: absolute;
  top: 35%;
  right: 1%;
}
.verify-invitation {
  left: 30px !important;
}
.h-line-avatar {
  width: 5px !important;
}
.h-line-avatar > span {
  width: 27px !important;
}
.img-m {
  margin-left: 1px;
}
.primary-text {
  color: #730ba9 !important;
}
</style>


<style lang="scss">
.custom_confirm {
  .swal2-actions:not(.swal2-loading) 
  .swal2-styled:hover {
    background-image: none !important ;  
  }
  .swal2-styled {
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none; 
  }
}

</style>